import { useNavigate } from "react-router-dom";
import ClockIcon from "../../assets/clockIcon.svg";
import { useEffect, useRef, useState } from "react";
import { PropertyCard } from "../CartView/propertyCard";
import { useModalStore } from "../../stores/handleModalStore";
import { useShowingCartStore } from "../../stores/showingCartStore";

const CheckoutCartPropertiesView = () => {
	const navigate = useNavigate();
	const { setCartModal, setMinCartModal } = useModalStore();
	const { setZlids, cartProperties } = useShowingCartStore();
	const [selectedProperties, setSelectedProperties] = useState<string[]>([]);
	const bottomRef = useRef<HTMLDivElement | null>(null);
	const [paddingBottom, setPaddingBottom] = useState(0);

	const handleCheckboxChange = (listingId: string, isChecked: boolean) => {
		setSelectedProperties((prevSelected) =>
			isChecked
				? [...prevSelected, listingId]
				: prevSelected.filter((id) => id !== listingId),
		);
	};

	const saveChanges = () => {
		try {
			if (selectedProperties.length > 8) {
				setMinCartModal(false);
				setCartModal(true);
			} else if (selectedProperties.length < 2) {
				setMinCartModal(true);
				setCartModal(true);
			} else {
				setZlids(selectedProperties);
				navigate("/cart/date-selection");
			}
		} catch (error) {
			console.error("Failed to save changes", error);
		}
	};

	useEffect(() => {
		const updatePadding = () => {
			if (bottomRef.current) {
				const buttonHeight = bottomRef.current.offsetHeight;
				setPaddingBottom(buttonHeight + 20);
			}
		};

		updatePadding();

		window.addEventListener("resize", updatePadding);

		return () => {
			window.removeEventListener("resize", updatePadding);
		};
	}, []);

	return (
		<div
			className="w-full text-black space-y-6 pt-2"
			style={{ paddingBottom: `${paddingBottom + 10}px` }}
		>
			<div className="w-full items-start flex flex-col text-start text-z-black space-y-2 px-2">
				<div className="font-semibold flex text-start text-3xl items-start justify-start w-full text-z-prussian-blue">
					Choose the Homes You Want to See
				</div>
				<div className="text-z-prussian-blue">
					Select up to 8 properties. The rest will remain in your cart.
				</div>
			</div>
			{cartProperties.map((property, index) => (
				<div key={property.listingId} className="space-y-6 px-2">
					<PropertyCard
						property={property}
						checkoutProperty={true}
						isChecked={selectedProperties.includes(property.listingId)}
						onCheckboxChange={handleCheckboxChange}
					/>
					{index !== cartProperties.length - 1 && <hr />}
				</div>
			))}
			<div
				className={`fixed w-full ${
					window.bridge ? "bottom-bridge-inset-bottom" : "bottom-5"
				} px-2`}
				ref={bottomRef}
			>
				<button
					type="button"
					onClick={saveChanges}
					disabled={selectedProperties.length === 0}
					className="bg-z-dark-moss-green w-full font-semibold text-[20px] disabled:bg-[#D9D9D9] text-white flex items-center justify-center gap-2 rounded-full py-3.5 shadow-md drop-shadow-md"
				>
					<img src={ClockIcon} alt="" />
					Choose a date
				</button>
			</div>
		</div>
	);
};

export { CheckoutCartPropertiesView };
